"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Singleton = void 0;
var environment_helper_1 = require("../helpers/environment.helper");
var UNIPOLSAI_INSTANCES_KEY = "__UNIPOLSAI_INSTANCES__";
var Singleton = /** @class */ (function () {
    function Singleton() {
    }
    Singleton.getInstance = function () {
        if (environment_helper_1.EnvironmentHelper.isClientSide() &&
            !environment_helper_1.EnvironmentHelper.isRunningTest()) {
            var className = this.className;
            if (!window[UNIPOLSAI_INSTANCES_KEY]) {
                window[UNIPOLSAI_INSTANCES_KEY] = {};
            }
            if (!!window[UNIPOLSAI_INSTANCES_KEY][className]) {
                return window[UNIPOLSAI_INSTANCES_KEY][className];
            }
            else {
                window[UNIPOLSAI_INSTANCES_KEY][className] = new this();
                return window[UNIPOLSAI_INSTANCES_KEY][className];
            }
        }
        else if (!!this._instance) {
            return this._instance;
        }
        else {
            this._instance = new this();
            return this._instance;
        }
    };
    Singleton.className = "Singleton";
    return Singleton;
}());
exports.Singleton = Singleton;
